// extracted by mini-css-extract-plugin
export default {"video":"Video_video__d1i6N","video__wrapper":"Video_video__wrapper__wRpAJ","video__iframe":"Video_video__iframe__S8rfp"};